import Axios from 'axios';

export default {
	getUpcomingEvents(sport) {
		return Axios.get(`/api/liveinplay/sportfixtures/${sport}/upcoming`)
			.then(response => {
				return response.data;
			})
			.catch(error => {
				this.error = error;
			})
	}
}